import React from 'react';
import { Link } from 'gatsby';
import { motion, AnimatePresence } from "framer-motion";

const containerVariants = {
  hidden: {},
  show: {
    transition: {
      staggerChildren: 0.06,
      delayChildren: 0.1,
    },
  },
};

const itemVariants = {
  hidden: { opacity: 0, y: -8 },
  show: { opacity: 1, y: 0 },
};

export function MobileNav({ navLinks, isExpanded, toggleExpansion, isCurrent }) {
  return (
    <AnimatePresence>
      {isExpanded && (
        <motion.div
          initial={{ height: 0, opacity: 0 }}
          animate={{ height: "auto", opacity: 1 }}
          exit={{ height: 0, opacity: 0 }}
          transition={{ duration: 0.25, ease: "easeOut" }}
          className="overflow-hidden md:hidden z-50"
        >
          <motion.div
            variants={containerVariants}
            initial="hidden"
            animate="show"
            exit="hidden"
            transition={{ duration: 0.25, ease: "easeOut" }}
            className="flex flex-col items-center gap-6 py-6"
          >
            {navLinks.map((link) => (
              <motion.div key={link.title} variants={itemVariants}>
                <Link
                  to={link.route}
                  onClick={() => toggleExpansion(false)}
                  className={`text-2xl text-white transition-opacity duration-200 hover:opacity-70 ${isCurrent(link.route) ? "underline" : ""
                    }`}
                >
                  {link.title}
                </Link>
              </motion.div>
            ))}
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}